/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'realname-auth-big': {
    width: 16,
    height: 16,
    viewBox: '0 0 96 96',
    data: '<defs/><g id="复杂大型图标"><path pid="0" class="cls-1" d="M20 32a16 16 0 0 0 16 16V16a16 16 0 0 0-16 16zM4 74.66V80h32V58.13C25.33 58.13 4 64 4 74.66z"/><path pid="1" class="cls-2" d="M52 32a16 16 0 0 0-16-16v32a16 16 0 0 0 16-16zM68 74.66C68 64 46.67 58.13 36 58.13V80h32zM60 20h32v8H60z"/><path pid="2" class="cls-1" d="M60 20h24v8H60z"/><path pid="3" class="cls-2" d="M60 36h32v8H60z"/><path pid="4" class="cls-1" d="M60 36h24v8H60zM84 52H66a28.55 28.55 0 0 1 10 6.11A12.76 12.76 0 0 1 77.54 60H84z"/><path pid="5" class="cls-2" d="M84 52h8v8h-8z"/></g>'
  }
})



// WEBPACK FOOTER //
// ./src/views/icons/realname-auth-big.js